import { StatusApprovalsEnum } from '@project-management-system/shared-models';
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, Unique, ManyToOne, JoinColumn } from 'typeorm';
import { FabricTrimsMasterVersions } from './fabric-trims-master-versions.entity';
import { MeasurementChart2TVersions } from './measurement-chart-2t-versions.entity';
import { MeasurementChartMonthsVersions } from './measurement-chart-6-12-months-versions.entity';
import { ApparelArticleMaster } from '../tech-pack/apparel-article-master.entity';


@Entity('_versions_apparel_article_master')
@Unique(["approvalStatus", "techPack"])
export class ApparelArticleMasterVersions {
    @PrimaryGeneratedColumn()
    id: number;

    @Column({ name: 'category', type: 'varchar', length: 255 })
    category: string;

    @Column({ name: 'sub_category', type: 'varchar', length: 255 })
    subCategory: string;

    @Column({ name: 'tech_pack', type: 'varchar', length: 255 })
    techPack: string;

    @Column({ name: 'season', type: 'varchar', length: 50 })
    season: string;

    @Column({ name: 'vendor', type: 'varchar', length: 255 })
    vendor: string;

    @Column({ name: 'department', type: 'varchar', length: 255 })
    department: string;

    @Column({ name: 'brand', type: 'varchar', length: 255 })
    brand: string;

    @Column({ name: 'collection', type: 'varchar', length: 255 })
    collection: string;

    @Column({ name: 'design_bom', type: 'varchar', length: 255 })
    designBOM: string;

    @Column({ name: 'bom_number', type: 'varchar', length: 50 })
    bomNumber: string;

    @Column({ name: 'status', type: 'varchar', length: 50 })
    status: string;

    @Column({ name: 'flow', type: 'varchar', length: 50 })
    flow: string;

    @Column({ name: 'remarks', type: 'text' })
    remarks: string;

    @Column({ name: 'buyer', type: 'varchar', length: 50 })
    buyer: string;

    @Column({ name: 'created', type: 'date' })
    created: Date;

    @Column({ name: 'modified', type: 'date' })
    modified: Date;

    @Column({ name: 'approval_status', nullable: false, type: 'enum', enum: StatusApprovalsEnum, default: StatusApprovalsEnum.HEAD_OF_QUALITY_APPROVED })
    approvalStatus: StatusApprovalsEnum;


    @Column({ name: 'role', type: 'varchar', length: 50 })
    role: string;

    @Column({ name: 'raw_data', type: 'text' })
    rawData: string;

    @OneToMany(() => FabricTrimsMasterVersions, (ft) => ft.versionApparelArticleId)
    versionsFabricId: FabricTrimsMasterVersions[];

    @OneToMany(() => MeasurementChart2TVersions, (ft) => ft.versionApparelArticleId)
    versionsMeasurementChart2t: MeasurementChart2TVersions[];

    @OneToMany(() => MeasurementChartMonthsVersions, (ft) => ft.versionApparelArticleId)
    versionsMeasurementChartMonths: MeasurementChartMonthsVersions[];

    @ManyToOne(() => ApparelArticleMaster, (am) => am.versionApparelArticle)
    @JoinColumn({ name: 'apparel_article_id' })
    apparelArticleId: ApparelArticleMaster;

    @CreateDateColumn({
        name: "created_at",
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user",
    })
    createdUser: string | null;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user",
    })
    updatedUser: string | null;

    @CreateDateColumn({
        name: "updated_at",
    })
    updatedAt: string;
}
